import React, {useState} from "react";
import {AiOutlineClose} from 'react-icons/ai';
import '../../css/ManagerPage.css'
import {Table} from "react-bootstrap";

const ManagerDetailModal =({setOnModalDetail,modalDetailItem})=>{
    console.log(modalDetailItem)

    return(
        <>
            <div className={'manager-modal-container scroll-auto manager-modal-detail-container'}>
                <div className={'manager-modal-close-box'}>
                    <AiOutlineClose size={20} style={{cursor:'pointer'}} onClick={()=>setOnModalDetail(false)}/>
                </div>
                <div className={'flex__column manager-modal-detail-user-information'}>
                    <span>고객명: {modalDetailItem.username}</span>
                    <span>휴대전화: {modalDetailItem.userphone}</span>
                    <span>주문시간: {modalDetailItem.usertime}</span>
                    {
                        modalDetailItem.pickupTime&&
                        <span>픽업시간: {modalDetailItem.pickupTime}</span>
                    }
                </div>
                <Table className={'cart-table-detail'}>
                    <thead className={'cart-table__thead'}>
                    <tr>
                        <th>주문번호</th>
                        <th>상품명/옵션</th>
                        <th>가격</th>
                        <th>수량</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        modalDetailItem.useritem.map((item,index)=>(
                            <tr key={index}>
                                <td>{index+1}</td>
                                <td>{item.name}</td>
                                <td>{item.price}</td>
                                <td>{item.quan}</td>
                            </tr>
                        ))
                    }
                    </tbody>
                    <tfoot>
                    <tr>
                        <th>전체금액: {modalDetailItem.priceAll} 원</th>
                    </tr>
                    </tfoot>
                </Table>
            </div>
        </>
    );
};
export default ManagerDetailModal;
